import { gql } from '@apollo/client'

export const CREATE_SUBSCRIPTION_PLAN = gql`
    mutation createSubscriptionPlan($input: CreateSubscriptionPlanInput!) {
        createSubscriptionPlan(input: $input) {
            code
            success
            message
        }
    }
`

export const UPDATE_SUBSCRIPTION_PLAN = gql`
    mutation updateSubscriptionPlan($subscription_id: NonEmptyString!, $input: UpdateSubscriptionPlanInput!) {
        updateSubscriptionPlan(subscription_id: $subscription_id, input: $input) {
            code
            success
            message
        }
    }
`

export const DELETE_SUBSCRIPTION_PLAN = gql`
    mutation deleteSubscriptionPlan($subscriptionCode: NonEmptyString!) {
        deleteSubscriptionPlan(subscription_code: $subscriptionCode) {
            code
            success
            message
        }
    }
`

export const ACTIVATE_SUBSCRIPTION_PLAN = gql`
    mutation activateSubscriptionPlan($subscription_id: NonEmptyString!) {
        activateSubscriptionPlan(subscription_id: $subscription_id) {
            code
            success
            message
        }
    }
`

export const DEACTIVATE_SUBSCRIPTION_PLAN = gql`
    mutation deactivateSubscriptionPlan($subscription_id: NonEmptyString!) {
        deactivateSubscriptionPlan(subscription_id: $subscription_id) {
            code
            success
            message
        }
    }
`
